export default __webpack_public_path__ + "static/media/mon_24.028b0024.png";